let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("73mUw")).then(() => parcelRequire('g1Gaf'));